import axios from 'axios'

export default{
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    async getDashboard ({commit, state, rootState}, args) {
      var apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/dashboard`
      return axios.get(apiPath).then((result) => {
        return result
      })
        .catch((e) => console.log(`Error: the server responded with '${e}: ${e}'`))
    }
  }
}
